<template>
  <component :is="tag" v-if="message">
    <slot :message="message">
      <help-tooltip mode="danger" :text="message"></help-tooltip>
    </slot>
  </component>
</template>

<script lang="ts">
  import Vue from "vue"
  import ChangeDetector from "../../../common/services/changeDetector";
  import ObjectModelProperty from "../../../common/models/objectModelProperties/objectModelProperty";
  import PublishedObjectModelDecorator from "../../../common/models/decorators/publishedObjectModelDecorator";
  import {ArrayHelper} from "../../../common/helpers/arrayHelper";
  import {StringHelper} from "../../../common/helpers/stringHelper";
  import {ObjectHelper} from "../../../common/helpers/objectHelper";

  export default Vue.extend({
    name: "property-change-detector",
    props: {
      tag: {
        type: String,
        default: 'span'
      },
      left: {
        type: Object as () => ObjectModelProperty,
        required: true,
      },
      right: {
        type: Object as () => PublishedObjectModelDecorator,
        required: false,
      },
      properties: {
        type: Array as () => Array<[string | Function, string]>, // [[<prop key or function>, <label in tooltip>]]
        required: false,
        default: () => [],
      },
    },
    data: function () {
      return {
        messageTemplate: "%{beginning} from published value",
      }
    },
    computed: {
      message(): string {
        let diffs: string[] = []
        this.properties.forEach(p => {
          if (!this.sameAsPublished(p[0])) diffs.push(p[1])
        })
        if (diffs.length > 0) {
          let beginning = ArrayHelper.toSentence(diffs.filter(d => d !== null && d !== undefined))
          if (beginning) {
            beginning += diffs.length === 1 ? ' differs' : ' differ'
          } else {
            beginning = 'Differs'
          }
          return this.interpolate(StringHelper.capitalize(beginning))
        }
      },
    },
    methods: {
      sameAsPublished(propType: string | Function): boolean {
        let getter
        if (typeof propType === 'function') {
          getter = propType
        } else {
          getter = m => ObjectHelper.dig(m, propType)
        }
        const changeDetector = new ChangeDetector({
          left: getter,
          right: getter,
          shouldCompare: (left, right, detector: ChangeDetector) => {
            return !!this.left && !!this.right
          },
        })
        return changeDetector.compare(this.left, this.right)
      },
      interpolate(text: string): string {
        return StringHelper.interpolate(this.messageTemplate, {beginning: text})
      },
    }
  })
</script>
